import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/firstLook/banner.jpg'
import navColor from '../../assets/firstLook/nav/color.jpg'
import navBgFixed from '../../assets/firstLook/nav/nav_bg_fixed.png'

import far1 from '../../assets/firstLook/nav/far1.png'
import far1_active from '../../assets/firstLook/nav/far1_active.png'
import far2 from '../../assets/firstLook/nav/far2.png'
import far2_active from '../../assets/firstLook/nav/far2_active.png'
import far3 from '../../assets/firstLook/nav/far3.png'
import far3_active from '../../assets/firstLook/nav/far3_active.png'

import son1 from '../../assets/firstLook/nav/son1.png'
import son1_active from '../../assets/firstLook/nav/son1_active.png'
import son2 from '../../assets/firstLook/nav/son2.png'
import son2_active from '../../assets/firstLook/nav/son2_active.png'
import son3 from '../../assets/firstLook/nav/son3.png'
import son3_active from '../../assets/firstLook/nav/son3_active.png'
import son4 from '../../assets/firstLook/nav/son4.png'
import son4_active from '../../assets/firstLook/nav/son4_active.png'
import son5 from '../../assets/firstLook/nav/son5.png'
import son5_active from '../../assets/firstLook/nav/son5_active.png'
import son6 from '../../assets/firstLook/nav/son6.png'
import son6_active from '../../assets/firstLook/nav/son6_active.png'
import son7 from '../../assets/firstLook/nav/son7.png'
import son7_active from '../../assets/firstLook/nav/son7_active.png'
import son8 from '../../assets/firstLook/nav/son8.png'
import son8_active from '../../assets/firstLook/nav/son8_active.png'
import son9 from '../../assets/firstLook/nav/son9.png'
import son9_active from '../../assets/firstLook/nav/son9_active.png'
import son10 from '../../assets/firstLook/nav/son10.png'
import son10_active from '../../assets/firstLook/nav/son10_active.png'
import son11 from '../../assets/firstLook/nav/son11.png'
import son11_active from '../../assets/firstLook/nav/son11_active.png'
import son12 from '../../assets/firstLook/nav/son12.png'
import son12_active from '../../assets/firstLook/nav/son12_active.png'
import son13 from '../../assets/firstLook/nav/son13.png'
import son13_active from '../../assets/firstLook/nav/son13_active.png'
import son14 from '../../assets/firstLook/nav/son14.png'
import son14_active from '../../assets/firstLook/nav/son14_active.png'
import son15 from '../../assets/firstLook/nav/son15.png'
import son15_active from '../../assets/firstLook/nav/son15_active.png'
import son16 from '../../assets/firstLook/nav/son16.png'
import son16_active from '../../assets/firstLook/nav/son16_active.png'
import son17 from '../../assets/firstLook/nav/son17.png'
import son17_active from '../../assets/firstLook/nav/son17_active.png'
import son18 from '../../assets/firstLook/nav/son18.png'
import son18_active from '../../assets/firstLook/nav/son18_active.png'
import son19 from '../../assets/firstLook/nav/son19.png'
import son19_active from '../../assets/firstLook/nav/son19_active.png'

import calcRemFn from '../calcRem'

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(145),
    backgroundImage: `url(${navColor})`,
    boxSizing: 'border-box'
  },
  navCtn: {
    height: calcRemFn(62),
  },
  navCtnFixed: {
    height: calcRemFn(145),
    backgroundImage: `url(${navBgFixed})`
  },
  topBtnLayout: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  topBtnBaseCss: {
    width: calcRemFn(48),
    padding: `${calcRemFn(10)} ${calcRemFn(7)} 0`,
  },
  bottomBtnLayout: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  bottomBtnBaseCss: {
    width: calcRemFn(34),
    // marginLeft: calcRemFn(0)
  },
}

const navData = {
  showLine2: true,
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    },
    {
      key: 'top3',
      show: true,
      img: far3,
      img_actived: far3_active,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active
      },
      {
        key: '_i4',
        show: true,
        img: son4,
        img_actived: son4_active
      },
      {
        key: '_i5',
        show: true,
        img: son5,
        img_actived: son5_active
      },
      {
        key: '_i6',
        show: true,
        img: son6,
        img_actived: son6_active
      },
      {
        key: '_i7',
        show: true,
        img: son7,
        img_actived: son7_active
      },
      {
        key: '_i8',
        show: true,
        img: son8,
        img_actived: son8_active
      },
      {
        key: '_i9',
        show: true,
        img: son9,
        img_actived: son9_active
      },
      {
        key: '_i10',
        show: true,
        img: son10,
        img_actived: son10_active
      }
    ],
    top2: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active
      },
      {
        key: '_i4',
        show: true,
        img: son4,
        img_actived: son4_active
      },
      {
        key: '_i5',
        show: true,
        img: son5,
        img_actived: son5_active
      },
      {
        key: '_i6',
        show: true,
        img: son6,
        img_actived: son6_active
      },
      {
        key: '_i7',
        show: true,
        img: son7,
        img_actived: son7_active
      },
      {
        key: '_i8',
        show: true,
        img: son8,
        img_actived: son8_active
      },
      {
        key: '_i9',
        show: true,
        img: son9,
        img_actived: son9_active
      },
      {
        key: '_i10',
        show: true,
        img: son10,
        img_actived: son10_active
      }
    ],
    top3: [
      {
        key: '_i1',
        show: true,
        img: son11,
        img_actived: son11_active
      },
      {
        key: '_i2',
        show: true,
        img: son12,
        img_actived: son12_active
      },
      {
        key: '_i3',
        show: true,
        img: son13,
        img_actived: son13_active
      },
      {
        key: '_i4',
        show: true,
        img: son14,
        img_actived: son14_active
      },
      {
        key: '_i5',
        show: true,
        img: son15,
        img_actived: son15_active
      },
      {
        key: '_i6',
        show: true,
        img: son16,
        img_actived: son16_active
      },
      {
        key: '_i7',
        show: true,
        img: son17,
        img_actived: son17_active
      },
      {
        key: '_i8',
        show: true,
        img: son18,
        img_actived: son18_active
      },
      {
        key: '_i9',
        show: true,
        img: son19,
        img_actived: son19_active
      }
    ]
  }
}

const pictureList = [
  {
    key: '1_1',
    picNum: 1,
    pid: 103441,
    brand: 'blue'
  },
  {
    key: '1_2',
    picNum: 1,
    pid: 103441,
    brand: 'blue'
  },
  {
    key: '1_3',
    picNum: 1,
    pid: 103441,
    brand: 'blue'
  },
  {
    key: '1_4',
    picNum: 1,
    pid: 103441,
    brand: 'blue'
  },
  {
    key: '1_5',
    picNum: 1,
    pid: 103441,
    brand: 'blue'
  },
  {
    key: '1_6',
    picNum: 1,
    pid: 103441,
    brand: 'blue'
  },
  {
    key: '1_7',
    picNum: 1,
    pid: 103441,
    brand: 'blue'
  },
  {
    key: '1_8',
    picNum: 1,
    pid: 103441,
    brand: 'blue'
  },
  {
    key: '1_9',
    picNum: 1,
    pid: 103441,
    brand: 'blue'
  },
  {
    key: '1_10',
    picNum: 1,
    pid: 103441,
    brand: 'blue'
  },
  {
    key: '2_1',
    picNum: 1,
    pid: 103440,
    brand: 'blue'
  },
  {
    key: '2_2',
    picNum: 1,
    pid: 103440,
    brand: 'blue'
  },
  {
    key: '2_3',
    picNum: 1,
    pid: 103440,
    brand: 'blue'
  },
  {
    key: '2_4',
    picNum: 1,
    pid: 103440,
    brand: 'blue'
  },
  {
    key: '2_5',
    picNum: 1,
    pid: 103440,
    brand: 'blue'
  },
  {
    key: '2_6',
    picNum: 1,
    pid: 103440,
    brand: 'blue'
  },
  {
    key: '2_7',
    picNum: 1,
    pid: 103440,
    brand: 'blue'
  },
  {
    key: '2_8',
    picNum: 1,
    pid: 103440,
    brand: 'blue'
  },
  {
    key: '2_9',
    picNum: 1,
    pid: 103440,
    brand: 'blue'
  },
  {
    key: '2_10',
    picNum: 1,
    pid: 103440,
    brand: 'blue'
  },
  {
    key: '3_1',
    picNum: 1,
    pid: 103439,
    brand: 'blue'
  },
  {
    key: '3_2',
    picNum: 1,
    pid: 103439,
    brand: 'blue'
  },
  {
    key: '3_3',
    picNum: 1,
    pid: 103439,
    brand: 'blue'
  },
  {
    key: '3_4',
    picNum: 1,
    pid: 103439,
    brand: 'blue'
  },
  {
    key: '3_5',
    picNum: 1,
    pid: 103439,
    brand: 'blue'
  },
  {
    key: '3_6',
    picNum: 1,
    pid: 103439,
    brand: 'blue'
  },
  {
    key: '3_7',
    picNum: 1,
    pid: 103439,
    brand: 'blue'
  },
  {
    key: '3_8',
    picNum: 1,
    pid: 103439,
    brand: 'blue'
  },
  {
    key: '3_9',
    picNum: 1,
    pid: 103439,
    brand: 'blue'
  }
]
function handlePictures (pictureList) {
  const pictures = []
  pictureList.forEach(item => {
    const { picNum, pid, key, startIndex = 0, brand } = item
    const picList = []
    Array(picNum).fill(0).forEach((item, index) => {
      picList.push(require(`../../assets/firstLook/ctn/${key}_${index + startIndex + 1}.jpg`))
    })
    const indexArr = key.split('_')
    pictures.push({
      id: pid,
      type: brand,
      ref: `top${indexArr[0]}_i${indexArr[1]}`,
      farName: `top${indexArr[0]}`,
      sonName: `_i${indexArr[1]}`,
      son: picList
    })
  })
  return pictures
}
const pictures = handlePictures(pictureList)

pictures.unshift({
  son: [
    require('../../assets/firstLook/ctn/1_0_1.jpg')
  ]
})

pictures.push({
  son: [
    require('../../assets/firstLook/ctn/3_10_1.jpg')
  ]
})

const topDiff = {
  firstSon: '_i1',
  top1_i1: -30,
  top2_i1: -30,
  top3_i1: -30,
  // top1_i2: 20,
  // top2_i1: 5,
  // top2_i2: 16,
}

export default {
  title: 'First Look',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff
}
